import jQuery from "jquery";

const $ = jQuery;

const advancedHeroSection = (($) => { // eslint-disable-line

  const me = {};
  const $pageSubNav = $('.page-sub-nav');
  const $enableSticky = $('.enable-link-sticky').length === 1;
  let wScrollBefore = 0;

  const removeAdvancedStickyButton = () => {

    $('.advanced-apply-link-sticky').removeClass('button--sticky');
    $('.advanced-apply-link-sticky').css('display', 'none');
    $('.advanced-apply-link-button').css('opacity', '1');

  };

  const addAdvancedStickyButton = () => {

    $('.advanced-apply-link-button').css('opacity', '0');
    $('.advanced-apply-link-sticky').addClass('button--sticky');
    $('.advanced-apply-link-sticky').css('display', 'inline-block');

  };

  const makeAdvancedSticky = () => {

    const scrollPosition = $(window).scrollTop();
    const applyLinkButton = $('.advanced-apply-link-button');
    if (!applyLinkButton.length) {
      return;
    }
    const applyLinkButtonOffsetTop = applyLinkButton.offset().top;
    let applyButtonMargin = applyLinkButtonOffsetTop - 10;

    if ($pageSubNav.length === 1) {

      const elHeight = $pageSubNav.outerHeight();
      const dHeight = $('body').height();
      const wHeight = $(window).height();

      if (scrollPosition > wScrollBefore) {

        // Down scroll
        if (scrollPosition + wHeight >= dHeight - elHeight) {

          // Scrolled to bottom of page
          $('.advanced-apply-link-sticky').css('top', '60px');
          applyButtonMargin = applyLinkButtonOffsetTop - 60;

        } else {

          $('.advanced-apply-link-sticky').css('top', '10px');

        }

      } else {

        // Scroll upp
        $('.advanced-apply-link-sticky').css('top', '60px');
        applyButtonMargin = applyLinkButtonOffsetTop - 60;

      }

    }

    wScrollBefore = scrollPosition;

    if ($(window).width() < 753) {

      if (applyButtonMargin > scrollPosition) {

        removeAdvancedStickyButton();

      } else {

        addAdvancedStickyButton();

      }

    } else {

      removeAdvancedStickyButton();

    }

  };

  me.init = function() {

    if ($enableSticky) {

      $(window).on('load', () => {

        makeAdvancedSticky();

      });

      $(window).on('scroll resize', () => {

        makeAdvancedSticky();

      });

    }

  };

  return me;

})(jQuery); // eslint-disable-line

export default advancedHeroSection;
